import {
  createContext,
  type ReactElement,
  type ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';
import styled from 'styled-components';

const Banner = styled.div`
  background: var(--grey-100);
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  margin: var(--component-margin);
  padding: 0.5rem 0.75rem;
`;

const NoticeContext = createContext<(message: string) => void>(() => {});

export const useNotice = (): ((message: string) => void) =>
  useContext(NoticeContext);

// A row's confirmation cannot live in the row: a rejected or passed-on student
// leaves the list as soon as it refetches.
export function NoticeProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const [message, setMessage] = useState('');
  const value = useMemo(() => setMessage, []);
  return (
    <NoticeContext.Provider value={value}>
      {message && <Banner role="status">{message}</Banner>}
      {children}
    </NoticeContext.Provider>
  );
}
